import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router";
function SignIn({ event }) {
  const location = useLocation();

  const redirectTo = location.state?.from || `/events/${event.event_slug}/`;
  const [signIn, setSignIn] = useState({
    email: "",
    event_slug: event?.event_slug || "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setSignIn((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch(`/api/events/signin/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signIn),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("access", data.access);
        setMessage(
          data.message || "You have successfully signed in for the workshop",
        );
        setSignIn({
          email: "",
        });

        window.location.href = redirectTo;
      } else {
        let errorMessage = "An error occurred. Please try again.";

        if (data.error) {
          errorMessage = data.error;
        } else if (typeof data === "object") {
          const firstKey = Object.keys(data)[0];
          const firstError = data[firstKey][0];
          errorMessage = firstError;
        }

        setMessage(errorMessage);
      }
    } catch (error) {
      setMessage("Network error: " + error.message);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (event?.event_slug) {
      setSignIn((prev) => ({
        ...prev,
        event_slug: event.event_slug,
      }));
    }
  }, [event?.event_slug]);

  return (
    <div>
      <div className="p-6 bg-black/50 place-content-center fixed inset-0">
        <form onSubmit={handleSubmit}>
          <div className="mx-auto grid max-w-lg grid-cols-1 gap-6 rounded-lg border border-gray-300 bg-gray-100 p-6 sm:grid-cols-2 mt-10">
            <div className="md:col-span-2">
              <label
                className="block text-sm mb-3 font-medium text-gray-900"
                htmlFor="email"
              >
                Email
              </label>
              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="email"
                type="email"
                placeholder="Your email"
                value={signIn.email}
                onChange={handleChange}
              />
            </div>

            <div className="md:col-span-2">
              <button
                className="block w-full  border border-indigo-600 bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition-colors hover:bg-transparent hover:text-indigo-600"
                type="submit"
              >
                {isLoading ? "signing in" : "SIGN IN"}
              </button>
            </div>
            <div>
              <button className="mt-4 flex justify-center mx-auto rounded-md bg-blue-700 px-5 py-3 font-medium text-white shadow-sm hover:bg-green-700">
                <Link to={`/events/${event.event_slug}/`}>
                  ← Back to event site
                </Link>
              </button>
            </div>
            <div>
              <button
                
                className="mt-4 flex justify-center mx-auto rounded-md bg-[#0166b1] px-5 py-3 font-medium text-white shadow-sm hover:bg-indigo-700"
              >
                <Link to={`/events/${event.event_slug}/registration`}>
                Register for the event
                </Link>
              </button>
            </div>
          </div>
        </form>
        {message && (
          <div className="max-w-lg mx-auto p-4 mb-4 text-center text-white bg-indigo-600 rounded">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default SignIn;
